"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
const vue_1 = require("vue");
const CardTitle_1 = require("./CardTitle");
const CardResourceCounter_1 = require("./CardResourceCounter");
const CardCost_1 = require("./CardCost");
const CardExtraContent_1 = require("./CardExtraContent");
const CardExpansion_1 = require("./CardExpansion");
const CardTags_1 = require("./CardTags");
const CardType_1 = require("../../cards/CardType");
const CardContent_1 = require("./CardContent");
const Tags_1 = require("../../cards/Tags");
const AllCards_1 = require("../../cards/AllCards");
const ResourceType_1 = require("../../ResourceType");
exports.Card = vue_1.default.component('card', {
    components: {
        CardTitle: CardTitle_1.CardTitle,
        CardResourceCounter: CardResourceCounter_1.CardResourceCounter,
        CardCost: CardCost_1.CardCost,
        CardExtraContent: CardExtraContent_1.CardExtraContent,
        CardExpansion: CardExpansion_1.CardExpansion,
        CardTags: CardTags_1.CardTags,
        CardContent: CardContent_1.CardContent,
    },
    props: {
        card: {
            type: Object,
            required: true,
        },
        actionUsed: {
            type: Boolean,
        },
        owner: {
            type: Object,
        },
        robotCard: {
            type: Object,
            required: false,
        }
    },
    data: function () {
        let cardInstance;
        const cardName = this.card.name;
        let expansion;
        for (const manifest of AllCards_1.ALL_CARD_MANIFESTS) {
            const decks = [
                manifest.corporationCards,
                manifest.projectCards,
                manifest.preludeCards,
                manifest.standardProjects,
                manifest.standardActions,
                manifest.turmoilActions,
                manifest.leaderCards,
            ];
            for (const deck of decks) {
                const factory = deck.findByCardName(cardName);
                if (factory !== undefined) {
                    cardInstance = new factory.Factory();
                    expansion = manifest.module;
                    break;
                }
            }
            if (expansion !== undefined) {
                break;
            }
        }
        if (cardInstance === undefined || expansion === undefined) {
            throw new Error(`Can't find card ${cardName}`);
        }
        return {
            cardInstance,
            expansion,
        };
    },
    methods: {
        getCardExpansion: function () {
            return this.expansion;
        },
        getCard: function () {
            return this.cardInstance;
        },
        getTags: function () {
            var _a;
            let result = [];
            const type = this.getCardType();
            const tags = (_a = this.getCard()) === null || _a === void 0 ? void 0 : _a.tags;
            if (tags !== undefined) {
                result = result.concat(tags);
            }
            if (type === CardType_1.CardType.EVENT) {
                result.push(Tags_1.Tags.EVENT);
            }
            return result;
        },
        getCost: function () {
            var _a;
            const cost = (_a = this.getCard()) === null || _a === void 0 ? void 0 : _a.cost;
            const type = this.getCardType();
            const excludedTypes = [CardType_1.CardType.PRELUDE, CardType_1.CardType.CORPORATION, CardType_1.CardType.LEADER, undefined];
            return cost === undefined || excludedTypes.includes(type) ? undefined : cost;
        },
        getReducedCost: function () {
            const cost = this.card.calculatedCost;
            const type = this.getCardType();
            const excludedTypes = [CardType_1.CardType.PRELUDE, CardType_1.CardType.CORPORATION, CardType_1.CardType.LEADER, undefined];
            return cost === undefined || excludedTypes.includes(type) ? undefined : cost;
        },
        getCardType: function () {
            var _a;
            return (_a = this.getCard()) === null || _a === void 0 ? void 0 : _a.cardType;
        },
        getCardClasses: function (card) {
            const classes = ['card-container', 'filterDiv', 'filterDiv-card', 'hover-hide-res'];
            if (card.warning !== undefined) {
                classes.push('filterDiv-card-with-warning');
            }
            classes.push('card-' + card.name.toLowerCase().replace(/ /g, '-'));
            if (this.actionUsed || card.isDisabled) {
                classes.push('card-unavailable');
            }
            if (this.isStandardProject()) {
                classes.push('card-standard-project');
            }
            return classes.join(' ');
        },
        getCardMetadata() {
            var _a;
            return (_a = this.getCard()) === null || _a === void 0 ? void 0 : _a.metadata;
        },
        getCardRequirements: function () {
            var _a;
            return (_a = this.getCard()) === null || _a === void 0 ? void 0 : _a.requirements;
        },
        getResourceAmount: function () {
            var _a;
            return this.card.resources || ((_a = this.robotCard) === null || _a === void 0 ? void 0 : _a.resources) || 0;
        },
        isCorporationCard: function () {
            return this.getCardType() === CardType_1.CardType.CORPORATION;
        },
        isStandardProject: function () {
            return this.getCardType() === CardType_1.CardType.STANDARD_PROJECT || this.getCardType() === CardType_1.CardType.STANDARD_ACTION;
        },
    },
    computed: {
        resourceType() {
            if (this.card.resourceType !== undefined)
                return this.card.resourceType;
            if (this.cardInstance.resourceType !== undefined)
                return this.cardInstance.resourceType;
            return ResourceType_1.ResourceType.RESOURCE_CUBE;
        },
        hasResourceType() {
            return this.card.resources !== undefined || this.robotCard !== undefined;
        }
    },
    template: `
        <div :class="getCardClasses(card)">
            <div class="card-content-wrapper" v-i18n>
                <div v-if="!isStandardProject()" class="card-cost-and-tags">
                    <CardCost :amount="getCost()" :newCost="getReducedCost()" />
                    <CardTags :tags="getTags()" />
                </div>
                <CardTitle :title="card.name" :type="getCardType()"/>
                <CardContent v-if="getCardMetadata() !== undefined" :metadata="getCardMetadata()" :requirements="getCardRequirements()" :isCorporation="isCorporationCard()"/>
            </div>
            <CardExpansion :expansion="getCardExpansion()" :isCorporation="isCorporationCard()"/>
            <CardResourceCounter v-if="hasResourceType" :amount="getResourceAmount()" :type="resourceType" />
            <CardExtraContent :card="card" />
            <template v-if="owner !== undefined">
              <div :class="'card-owner-label player_translucent_bg_color_'+ owner.color">
                {{owner.name}}
              </div>
            </template>
        </div>
    `,
});
//# sourceMappingURL=Card.js.map